
import './App.css';
import Checkout from './Checkout';
import Header from './Header';
import Home from './Home';
import  {Routes, Route} from "react-router-dom"
import Login from './Login';
import { UseStateValue } from './Stateprovider';
import Orders from './Orders';
import { auth } from './Firebase';
import React, { useEffect } from 'react';
import Payment from './Payment';
import { loadStripe } from '@stripe/stripe-js';
import {Elements} from "@stripe/react-stripe-js"

const promise =loadStripe(
'pk_test_51N2EsZKqt27jmWHmRAnPLJLdOiprEFDa2VTuOeovCj3T03P1gcV6iv3Wd3eJ4cyICijAd1rBwhFd7cdvVRg5ZLIY00OTsuPXyo')

function App() {
  const [{}, dispatch] = UseStateValue();
  useEffect(() => {
auth.onAuthStateChanged((authUser) => {
  if(authUser) {
    dispatch({
      type: "SET_USER",
      user: authUser,
    });
  } else {
    dispatch({
      type: "SET_USER",
      user: null,
    });
  }
});
  },[]);
  return (
    <div className='App'>
      <Routes>
        <Route path='/Checkout' element={<><Header/><Checkout/></>}/>
        <Route path='/orders' element={<><Header/><Orders/></>}/>
        <Route path='/payment' element={<><Header/>
        <Elements stripe={promise}> 
        <Payment/>
        </Elements></>}/>
        <Route path='/login' element={<><Header/><Login/></>
      }/>
        <Route path='/' element={
          <>
            <Header/>
            <Home/>
            </>
        }/>
    </Routes>
    </div>
  );
}

export default App;
